import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=528b6df7&scoped=true"
import script from "./NovoUsuario.vue?vue&type=script&lang=ts"
export * from "./NovoUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b6df7",
  null
  
)

export default component.exports